<template>
    <div class="py-4">
        <modal-filter :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="ONFILTER()"
            :exclude="['state_id', 'payment_state_id']" />
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Bodega</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2"
                                        :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status"
                                        v-if="loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status"
                                        v-if="loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between" v-if="globalViewOption('WarehouseAsigned')">
                        <div class="d-flex gap-3 row">
                            <div class="col-md-3 px-0">
                                <v-combobox v-model="form.awb" :items="awbs" item-text="awb" item-value="awb"
                                    :search-input.sync="search_awbs" hide-details placeholder="Seleccione o ingrese AWB..."
                                    @change="CHANGE_AWB" class="form-control form-control-sm">
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            {{ loading == 'awbs' ? 'Buscando...' : 'No hay datos disponibles' }}
                                        </v-list-item>
                                    </template>
                                </v-combobox>
                            </div>
                            <div class="col-md-3 px-0">
                                <v-combobox v-model="form.hawb" :items="hawbs" item-text="hawb" item-value="hawb"
                                    :search-input.sync="search_hawbs" hide-details
                                    placeholder="Seleccione o ingrese HAWB..." @change="CHANGE_HAWB"
                                    class="form-control form-control-sm">
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            {{ loading == 'hawbs' ? 'Buscando...' : 'No hay datos disponibles' }}
                                        </v-list-item>
                                    </template>
                                </v-combobox>
                            </div>
                            <div>
                                <button type="button" @click="ASIGNED" class="btn btn-h px-3 btn-success">
                                    <span>Asignar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table class="elevation-1" :headers="headers"
                                    :items="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear' ? [] : items.data" :show-select="globalViewOption('WarehouseAsigned')" v-model="form.selected"
                                    :options.sync="options" :server-items-length="items.total" :loading="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                                        <v-simple-checkbox :ripple="false" :value="isSelected" @input="select($event)">
                                        </v-simple-checkbox>
                                    </template>
                                    <template v-slot:[`item.id`]="{ item }">
                                        {{ item.type }}{{ item.id }}
                                    </template>
                                    <template v-slot:[`item.pieces`]="{ item }">
                                        {{ Number(item.pieces || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.lengthy`]="{ item }">
                                        {{ Number(item.lengthy || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.width`]="{ item }">
                                        {{ Number(item.width || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.tall`]="{ item }">
                                        {{ Number(item.tall || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.weight`]="{ item }">
                                        {{ Number(item.weight || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.state.name`]="{ item }">
                                        <span class="badge badge-pill"
                                            :class="item.state.labels ? item.state.labels : 'badge-light'">{{
                                                item.state.name }}</span>
                                    </template>
                                    <template v-slot:[`item.description`]="{ item }">
                                        <v-tooltip bottom class="mx-1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(item.description)">
                                                    {{ item.description[0] }} ...
                                                </div>
                                            </template>
                                            <small>
                                                <div v-for="(description, key) in  item.description" :key="key">{{
                                                    description }}</div>
                                            </small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.created_at`]="{ item }">
                                        {{ item.created_at | DATE }}
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item, index }">
                                        <div class="d-flex gap-3">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="PRINT_WAREHOUSE(item.id, index)" type="button"
                                                        v-bind="attrs" v-on="on" class="btn btn-neutral btn-m">
                                                        <small class="d-flex justify-content-center align-items-center">
                                                            <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="print_wr.filter(e => e == index).length == 1">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <i class="bi bi-printer" v-else></i>
                                                        </small>
                                                    </button>
                                                </template>
                                                <small>Imprimir Certificado de depósito</small>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="PRINT_TAG(item.id, index)" type="button" v-bind="attrs"
                                                        v-on="on" class="btn btn-danger btn-m">
                                                        <small class="d-flex justify-content-center align-items-center">
                                                            <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="print_tag.filter(e => e == index).length == 1">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <i class="bi bi-printer" v-else></i>
                                                        </small>
                                                    </button>
                                                </template>
                                                <small>Imprimir TAG</small>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
export default {
    components: { ModalFilter },
    data() {
        return {
            headers: [
                { text: 'WH #', value: 'id', sortable: false },
                { text: 'Tracking', value: 'tracking', sortable: false },
                { text: 'Consignatario', value: 'user.name', sortable: false },
                { text: 'Piezas', value: 'pieces', sortable: false },
                { text: 'Embalaje', value: 'packing.name', sortable: false },
                { text: 'Descripción', value: 'description', sortable: false },
                { text: 'Largo', value: 'lengthy', sortable: false },
                { text: 'Ancho', value: 'width', sortable: false },
                { text: 'Altura', value: 'tall', sortable: false },
                { text: 'Peso', value: 'weight', sortable: false },
                { text: 'Estado', value: 'state.name', sortable: false },
                { text: 'Creado', value: 'created_at', sortable: false },
                { text: 'Acción', value: 'actions', sortable: false }
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: '',
            print_wr: [],
            print_tag: [],
            form: {
                awb: '',
                hawb: '',
                selected: [],
            },
            options: {},
            filter: {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'DESC',
                fields: ['id', 'tracking', 'description'],
                search: '',
            },
            cancelToken: null,
            onfilter: false,
            count: 0,
            awbs: [],
            hawbs: [],
            search_awbs: '',
            search_hawbs: '',
            BASE: process.env.BASE,
        }
    },
    mounted() {
        this.AWBS()
        this.$store.dispatch('MAXPAGE')
    },
    computed: {
        count_filter: function () {
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if (e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search') {
                    if (typeof e[1] == 'object') {
                        if (e[1]) {
                            if (e[1].length > 0) {
                                count++
                            }
                        }
                    } else {
                        if (e[1]) {
                            count++
                        }
                    }
                }
            })
            return count;
        }
    },
    methods: {
        AWBS: function () {
            let vue = this
            axios({ url: '/open/awbs', method: 'GET' })
                .then((resp) => {
                    vue.awbs = resp.data
                })
        },
        INIT: function () {
            let vue = this
            vue.loading = 'table'

            const source = axios.CancelToken.source()
            vue.cancelToken = source
            const { page, itemsPerPage } = vue.options

            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }

            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })

            axios({
                url: '/warehouse',
                method: 'GET',
                params: query,
                cancelToken: source.token
            })
                .then((resp) => {
                    vue.items = resp.data
                    vue.loading = ''
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                        let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        },
        SORT: function () {
            let vue = this
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.loading = 'sort'
            vue.INIT()
        },
        ONFILTER: function(){
            let vue = this
            vue.onfilter = false
            vue.loading = 'table'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        PRINT_WAREHOUSE: function (print, index) {
            let vue = this
            if (vue.print_wr.filter(e => e == index).length == 0) {
                vue.print_wr.push(index)
                axios({ url: '/print/package/' + print + '/wr', method: 'GET', responseType: 'blob' })
                    .then((response) => {
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(response.data)
                        link.target = '_blank'
                        link.rel = "noopener"
                        link.click()
                    })
                    .finally((resp) => {
                        vue.print_wr.splice(vue.print_wr.findIndex(e => e == index), 1)
                    })
            }
        },
        PRINT_TAG: function (print, index) {
            let vue = this
            if (vue.print_tag.filter(e => e == index).length == 0) {
                vue.print_tag.push(index)
                axios({ url: '/print/package/' + print + '/tag', method: 'GET', responseType: 'blob' })
                    .then((response) => {
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(response.data)
                        link.target = '_blank'
                        link.rel = "noopener"
                        link.click()
                    })
                    .finally((resp) => {
                        vue.print_tag.splice(vue.print_tag.findIndex(e => e == index), 1)
                    })
            }
        },
        CHANGE_AWB: function (e) {
            let vue = this
            vue.awbs.forEach((element, index) => {
                if (element.id == null) {
                    vue.awbs.splice(index, 1)
                }
            })
            vue.form.hawb = ''
            vue.hawbs = []
            vue.form.awb = e ? e.awb : ''
        },
        APPEND_AWB: function (awb) {
            this.awbs.push({ awb: awb, id: null })
        },
        CHANGE_HAWB: function (e) {
            let vue = this
            vue.hawbs.forEach((element, index) => {
                if (element.id == null) {
                    vue.hawbs.splice(index, 1)
                }
            })
            vue.form.hawb = e ? e.hawb : ''
        },
        APPEND_HAWB: function (hawb) {
            this.hawbs.push({ hawb: hawb, id: null })
        },
        ASIGNED: function () {
            let vue = this
            vue.count++
            if (vue.count == 1) {
                let data = {
                    awb: vue.form.awb,
                    hawb: vue.form.hawb,
                    selected: vue.form.selected.map(e => { return e.id })
                }
                axios({ url: '/awbs', method: 'POST', data: data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.form.awb = ''
                        vue.form.hawb = '',
                            vue.form.selected = [],
                            vue.awbs = []
                        vue.hawbs = []
                        vue.AWBS()
                        vue.INIT()
                    })
                    .catch((err) => {
                        if (err.response.status === 422) {
                            vue.errors = err.response.data
                        } else if (err.response.status === 402) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else if (err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        },
        FILTER: function () {
            let vue = this
            let count = 0
            if (vue.filter.search.length > 0) {
                count++
            }
            if (count > 0) {
                vue.loading = 'filter'
                if (vue.cancelToken) {
                    vue.cancelToken.cancel("Solicitud cancelada");
                }
                vue.INIT()
            }
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            vue.filter = {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'DESC',
                fields: ['id', 'tracking', 'description'],
                search: '',
            }
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
    },
    watch: {
        options: {
            handler() {
                if (this.cancelToken) {
                    this.cancelToken.cancel("Solicitud cancelada");
                }
                this.loading = 'table'
                this.INIT()
            },
            deep: true
        },
        search_awbs: {
            handler(value) {
                let vue = this
                if (value) {
                    vue.loading = 'awbs'
                    vue.form.hawb = ''
                    vue.hawbs = []
                    setTimeout(() => {
                        if (vue.search_awbs.length == value.length) {
                            let item = vue.awbs.find(e => e.awb == value)
                            if (item) {
                                vue.hawbs = item.hawbs
                            } else {
                                vue.APPEND_AWB(value)
                            }
                            vue.loading = ''
                        }
                    }, 500)
                }
            }
        },
        search_hawbs: {
            handler(value) {
                let vue = this
                if (value) {
                    vue.loading = 'hawbs'
                    setTimeout(() => {
                        if (vue.search_hawbs.length == value.length) {
                            let item = vue.hawbs.find(e => e.hawb == value)
                            if (!item) {
                                vue.APPEND_HAWB(value)
                            }
                            vue.loading = ''
                        }
                    }, 500)
                }
            }
        }
    }
}
</script>
